var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { paginatedQuery } from 'lib-shared-api-utils';
import { api } from 'utils/apis/api';
export const tagsApi = api.injectEndpoints({
    endpoints: (builder) => ({
        readTags: builder.query({
            query: (arg) => paginatedQuery(arg, ({ state: active_state }) => ({
                version: 2,
                path: 'tags/conversation',
                params: {
                    active_state,
                },
            })),
        }),
        readTagCategories: builder.query({
            query: () => ({
                version: 1,
                path: 'tags/categories',
            }),
        }),
        readTagsByName: builder.query({
            query: ({ names }) => ({
                version: 2,
                path: 'tags/conversation',
                params: {
                    names: names.join(','),
                },
            }),
        }),
        createTag: builder.mutation({
            query: (body) => ({
                version: 1,
                method: 'POST',
                path: 'tags/conversation',
                body,
            }),
        }),
        updateTagActiveState: builder.mutation({
            query: ({ tag, isActive }) => ({
                version: 1,
                method: 'PATCH',
                path: `tags/${tag.id}/${isActive ? 'activate' : 'deactivate'}`,
            }),
        }),
        updateTagFavoriteState: builder.mutation({
            query: ({ tag, isFavorite }) => ({
                version: 1,
                method: 'PATCH',
                path: `tags/${tag.id}/${isFavorite ? 'favorite' : 'unfavorite'}`,
            }),
            onQueryStarted({ tag, isFavorite }, { dispatch, queryFulfilled }) {
                return __awaiter(this, void 0, void 0, function* () {
                    const patchResult = dispatch(tagsApi.util.updateQueryData('readTagCategories', undefined, (draft) => {
                        const favoriteCategory = draft.data.categories.find(({ id }) => id === 'favorite');
                        if (favoriteCategory) {
                            const tags = favoriteCategory.items;
                            if (isFavorite) {
                                tags.push(tag);
                            }
                            else {
                                tags.splice(tags.findIndex(({ id }) => id === tag.id), 1);
                            }
                        }
                    }));
                    try {
                        yield queryFulfilled;
                    }
                    catch (_a) {
                        patchResult.undo();
                    }
                });
            },
        }),
        deleteTag: builder.mutation({
            query: ({ id }) => ({
                version: 1,
                method: 'DELETE',
                path: `tags/conversation/${id}`,
            }),
        }),
    }),
});
